import { createFileRoute } from "@tanstack/react-router";
import { SignInPage } from "@/features/auth/login.page";

export const Route = createFileRoute("/login/")({
  component: SignInPage,
});
